import React, {useState} from 'react';
import {
  Button,
  Collapse,
  Divider,
  Icon,
  IconButton,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Chip,
  Typography,
  TextField
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { giftCodeDeliveryMethods, giftCardStatus } from 'helpers/giftCards';


const GiftCodesTableFilterDrawer = ({setOpenFilter, setFilterConditions, filterConditions}) => {
  const [expandedStatus, toggleExpandedStatus] = useState(false);
  const [expandedDelivery, toggleExpandedDelivery] = useState(false);
  const [expandedCustomer, toggleExpandedCustomer] = useState(false);
  const [conditions, setConditions] = useState({
    customer_name: {
      field: 'customer_name',
      value: filterConditions.customer_name?.value || '',
      conditionType: 'like'
    },
    delivery_method: {
      field: 'delivery_method',
      value: filterConditions.delivery_method?.value || '',
      conditionType: 'eq'
    },
    status: {
      field: 'status',
      value: filterConditions.status?.value || '',
      conditionType: 'eq'
    },
  });

  const handleChangeFilter = (field, value, conditionType, name) => {
    setConditions((conditions) => (
      {
        ...conditions,
        [name]: {
          field,
          value,
          conditionType
        }
      }
    ));
  };

  const handleApplyFilter = () => {
    setFilterConditions(conditions);
    setOpenFilter(false);
  };

  return (
    <div className="px-4 pt-4 min-h-full-screen flex-column justify-between">
      <div>
        <div className="flex items-center justify-between mb-2">
          <Typography variant="h5" className="text-primary uppercase">Filter by:</Typography>
          <IconButton onClick={() => setOpenFilter(false)}>
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
        <div className="flex items-center flex-wrap mb-2">
          {Object.values(conditions).map((filterItem, index) => {
            if (!filterItem.value) {
              return null;
            }

            let label = filterItem.value;
            const fieldName = filterItem.field;

            if (filterItem.field === 'customer_name') {
              label = `Customer: ${filterItem.value.replace(/%/g, '')}`;
            }

            if (filterItem.field === 'delivery_method') {
              label = `Delivery Method: ${giftCodeDeliveryMethods[filterItem.value]}`;
            }

            if (filterItem.field === 'status') {
              label = `Status: ${giftCardStatus[filterItem.value]}`;
            }

            return (
              <div key={`filter-${index}`} className="mr-2 mb-2">
                <Chip
                  label={label}
                  onDelete={() => {
                    setConditions({
                      ...conditions,
                      [fieldName]: {
                        ...conditions[fieldName],
                        value: ''
                      }
                    });
                  }}
                />
              </div>
            );
          })}
        </div>
        <div>
          <Divider className="my-5" />
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => toggleExpandedStatus((expandedStatus) => !expandedStatus)}
          >
            <Typography variant="h6">Status</Typography>
            {expandedStatus ? <ExpandLess /> : <ExpandMore />}
          </div>
          <Collapse in={expandedStatus} timeout="auto">
            <FormControl component="div">
              <RadioGroup
                aria-label="status"
                name="status"
                value={conditions?.status?.value || ''}
                onChange={({target: {value, name}}) => handleChangeFilter(name, value, 'eq', name)}
              >
                {Object.keys(giftCardStatus).map((status) => (
                  <FormControlLabel
                    key={`gift-code-status-${status}`}
                    value={status}
                    control={<Radio color="primary" size="small" />}
                    label={giftCardStatus[status]}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Collapse>
          <Divider className="my-5" />
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => toggleExpandedDelivery((expandedDelivery) => !expandedDelivery)}
          >
            <Typography variant="h6">Delivery</Typography>
            {expandedDelivery ? <ExpandLess /> : <ExpandMore />}
          </div>
          <Collapse in={expandedDelivery} timeout="auto">
            <FormControl component="div">
              <RadioGroup
                aria-label="delivery_method"
                name="delivery_method"
                value={conditions?.delivery_method?.value || ''}
                onChange={({target: {value, name}}) => handleChangeFilter(name, value, 'eq', name)}
              >
                {Object.keys(giftCodeDeliveryMethods).map((method) => (
                  <FormControlLabel
                    key={`gift-code-method-${method}`}
                    value={method}
                    control={<Radio color="primary" size="small" />}
                    label={giftCodeDeliveryMethods[method]}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Collapse>
          <Divider className="my-5" />
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => toggleExpandedCustomer((expandedCustomer) => !expandedCustomer)}
          >
            <Typography variant="h6">Customer</Typography>
            {expandedCustomer ? <ExpandLess /> : <ExpandMore />}
          </div>
          <Collapse in={expandedCustomer} timeout="auto">
            <TextField
              fullWidth
              variant="outlined"
              className="my-5"
              name="customer_name"
              label="Customer"
              value={conditions.customer_name.value.replace(/%/g, '')}
              onChange={(event) => {
                const {name, value} = event.target;
                handleChangeFilter(name, `%${value}%`, 'like', name);
              }}
            />
          </Collapse>
          <Divider className="my-5" />
        </div>
      </div>
      <div className="flex items-center justify-between pb-4">
        <Button
          variant="contained"
          color="primary"
          fullWidth
          className="mr-2 uppercase"
          onClick={handleApplyFilter}
        >
          Apply Filters
        </Button>
        <Button
          variant="outlined"
          fullWidth
          className="uppercase"
          onClick={() => {
            setFilterConditions({});
            setOpenFilter(false);
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default GiftCodesTableFilterDrawer;
